import { Dbs } from '../constants'
import { db, checkError } from '../utils'

export function isLoggedIn() {

    return retrieveSession().then((session) => {

        return session !== null && session !== undefined

    }).catch(() => {

        return false
    })
}

export function retrieveSession() {

    const collection = db.collection(Dbs.COLLECTION_SESSION)

    return collection.findOne({})
        .then((session) => session)
        .catch(() => null)
}

export function clearSession() {

    const collectionSession = db.collection(Dbs.COLLECTION_SESSION)

    return collectionSession.remove({}, checkError)
      .then(() => true)
      .catch(() => false)
}

export function updateSession(params) {

    const collection = db.collection(Dbs.COLLECTION_SESSION)

    return collection.remove({}, checkError)
        .then(() => collection.insert(params, checkError))
        .then(() => true)
        .catch(() => false)
}

export function clearAll() {

    return clearSession()
        .then(() => clearState())
        .then(() => clearTmp())
        .catch(() => false)
}

export function retrieveState() {

    const collection = db.collection(Dbs.COLLECTION_STATE)

    return collection.findOne({})
        .then((state) => state)
        .catch(() => null)
}

export function clearState() {

    const collectionState = db.collection(Dbs.COLLECTION_STATE)

    return collectionState.remove({}, checkError)
      .then(() => true)
      .catch(() => false)
}

export function updateState(params) {

    const collection = db.collection(Dbs.COLLECTION_STATE)

    return retrieveState()
        .then((state) => {

            params = { ...state, ...params }

            return collection.remove({}, checkError)
                .then(() => collection.insert(params, checkError))
                .then(() => true)
                .catch(() => false)
        })
        .catch(() => false)
}

export function retrieveTmp() {

    const collection = db.collection(Dbs.COLLECTION_TMP)

    return collection.findOne({})
        .then((tmp) => tmp)
        .catch(() => null)
}

export function clearTmp() {

    const collectionTmp = db.collection(Dbs.COLLECTION_TMP)

    return collectionTmp.remove({}, checkError)
      .then(() => true)
      .catch(() => false)
}

export function updateTmp(params) {

    const collection = db.collection(Dbs.COLLECTION_TMP)

    return collection.remove({}, checkError)
        .then(() => collection.insert(params, checkError))
        .then(() => true)
        .catch(() => false)
}
